import { atom } from 'jotai';

export interface ISearchApiConfig {
  sourcing: boolean;
  portfolio: boolean;
}

export const searchApiConfigAtom = atom<ISearchApiConfig>({
  sourcing: false,
  portfolio: true,
});
